import React from "react";
import { NumericFormat } from "react-number-format";

export default function CurrencyFormat(props) {
  React.useEffect(() => {
    if (props.debugLog) console.dir(props);
  }, [props.debugLog, props.value]);

  return (
    <NumericFormat
      value={props.value}
      displayType={"text"}
      thousandSeparator={"."}
      decimalSeparator={","}
      decimalScale={2}
      fixedDecimalScale={true}
      renderText={(formattedValue) => (typeof props.renderText === "function" ? props.renderText(formattedValue) : <div>{formattedValue}</div>)}
    ></NumericFormat>
  );
}
